import React from 'react'
import { i18n } from '../../../validator'
import Modal from '../../../components/modal'
import Configurator from '../../../configurator'
import Button from '../../../front/components/shared/sn-button'

@i18n()
export default class SocialBanner extends Configurator {

    state = {
        banner: {
            image: '/images/sportnect/sportnasspojuje.png',
            linkInstagram: this.config.REACT_APP_FOOTER_INSTAGRAM_LINK,
            linkFacebook: this.config.REACT_APP_FOOTER_FACEBOOK_GROUP_LINK,
            linkTikTok: this.config.REACT_APP_FOOTER_TIKTOK_LINK,
            linkArticles: '/news',
        },
    }

    /**
     * Render button in banner
     *
     * @param {string} title
     * @param {string} link
     * @param {boolean} isOutLink
     * @returns {*}
     */
    renderBannerButton = (title, link, isOutLink) => (
        <Button
            className="btn btn-color-brand btn-lg m-2"
            onClick={() => this.hideModal()}
            target={isOutLink ? '_blank' : null}
            href={link}
        >
            {title}
        </Button>
    )

    /**
     * Set local storage item if banner has been showed
     */
    hideModal = () => {
        localStorage.setItem('socialBannerShowed', true)
    }

    render = () => {
        const { banner } = this.state
        const { t } = this.props

        // TODO temporary social banner is hidden for all users
        if (true) {
            return null
        }

        return (
            <Modal
                description={t('socialBanner.title')}
                handleHideModal={this.hideModal}
                dialogClass="modal-dialog--landing"
                content={() => (
                    <div className="p-2">
                        <div className="d-flex flex-column justify-content-center text-center">
                            <img alt="" src={banner.image} />
                        </div>
                        <div className="d-flex flex-column bg-secondary text-light justify-content-center text-center p-2">
                            {t('watchUs')}
                        </div>
                        <div className="d-flex justify-content-center p-2 flex-wrap">
                            {this.renderBannerButton('TikTok', banner.linkTikTok, true)}
                            {this.renderBannerButton('Instagram', banner.linkInstagram, true)}
                            {this.renderBannerButton('Facebook', banner.linkFacebook, true)}
                            {this.renderBannerButton(t('blog'), banner.linkArticles, false)}
                        </div>
                    </div>
                )}
            />
        )
    }
}
